<template>
  <div class="register-success-wrap">
    <svg-icon name="person_check"
              size="50"></svg-icon>
    <h1>{{ $t('register.success') }}</h1>
    <p>{{ $t('register.success_content_1') }}</p>
    <p>{{ $t('register.success_content_2') }}</p>
    <div class="reserve-btn"
         @click="goHome(route.query)">{{ $t('register.start_reserve') }}
    </div>
  </div>
</template>
<script setup>
import {onMounted} from "vue";
import {useUserStore} from "@/stores/user";
import {useGoTo} from "@/composables/useGoTo";
const { $fbq } = useNuxtApp()
const route = useRoute();

const userStore = useUserStore()
const {goHome} = useGoTo();

onMounted(() => {
  userStore.updateUserInfo()
  $fbq('trackCustom', 'OSUserRegister')
})


</script>
<style scoped
       lang="scss">
.register-success-wrap {
  @apply mt-[207px] flex flex-col items-center justify-center;
  h1 {
    @apply text-[23px] font-bold mt-[16px];
  }

  p {
    @apply text-[16px] text-center;
  }


  .reserve-btn {
    @apply absolute bottom-[55px] w-[70%] h-[50px] rounded-full text-center bg-osn-yellow-00
    text-[16px] font-semibold leading-[50px] cursor-pointer
    md:w-[320px];

  }
}

</style>
